import {
  BACKGROUND_THEME_COLOR_FIELD_TYPE,
  backgroundThemeHandlerEventBroker,
  CHANGE_BACKGROUND_THEME_COLOR
} from '@frontend/group/modules/background-theme-color/button-handler';
import { isInGroup } from '@frontend/utils';
import { getBackgroundColor } from '@/common/preview/get-background-color';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import {ThemesContainerSingleton} from "@/banner_template/themes/ThemesContainerSinglton";
import { getBackgroundColorGeometry } from './background-color-geometry';

const getScopePage = () => ShowPageScopeCollector.get(['updateLayoutChanges']);

export async function setBackgroundColor({
   fields,
   data,
   canvas,
   group_fields,
   dimension,
   id,
   themes,
   template,
}) {
  canvas.getObjects().forEach(function (o) {
    if (o.id === 'pixel_background') {
      canvas.remove(o);
    }
  });

  const { updateLayoutChanges } = getScopePage();

  const selectedTheme = await ThemesContainerSingleton.getThemeById(data?.theme);

  let background_color_values = data['background_color'];
  const BGColorFields = fields.filter(field =>
    field.type === BACKGROUND_THEME_COLOR_FIELD_TYPE &&
    (!group_fields || !group_fields || isInGroup(group_fields, field.name))
  );
  BGColorFields.forEach((field, i) => {
    let options = JSON.parse(field.options);
    let fill = background_color_values?.[i];
    if (!fill && selectedTheme) {
      fill = typeof selectedTheme.getBackgroundColors === 'function' 
        ?  selectedTheme?.getBackgroundColors()?.getFirstColor()?.fullColor 
        : '#ffffff';
    }

    fill = fill ? getBackgroundColor(fill) : null;
    const visible = !options['Hidden'];
    const geometry = getBackgroundColorGeometry(options, dimension, template);

    const rect = new fabric.Rect({
      id: 'pixel_background',
      ...geometry,
      height: geometry.height + 1,
      fill,
      selectable: false,
      evented: false,
      visible
    });
    
    canvas.add(rect);
    canvas.sendToBack(rect);

    backgroundThemeHandlerEventBroker
      .on(CHANGE_BACKGROUND_THEME_COLOR, ({ field: fieldChanged, instanceId }) => {
        if (id !== instanceId || field.id !== fieldChanged.id) {
          return;
        }

        rect.set('fill', getBackgroundColor(fieldChanged.value));

        canvas.renderAll();
        if (!background_color_values) {
          background_color_values = BGColorFields.map(() => '');
        }
        const indexInDateModel = BGColorFields.findIndex(bgColorField => bgColorField.id === fieldChanged.id);
        background_color_values.splice(indexInDateModel, 1, fieldChanged.value);

        updateLayoutChanges(id, 'background_color', background_color_values);
      });
  });

  canvas.renderAll();
}
